import { render, staticRenderFns } from "./faceDetail.vue?vue&type=template&id=3f3414b0"
import script from "./faceDetail.vue?vue&type=script&lang=js"
export * from "./faceDetail.vue?vue&type=script&lang=js"
import style0 from "./faceDetail.vue?vue&type=style&index=0&id=3f3414b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports